import PropTypes from "prop-types";
import styles from "./styles";

export default function PremierPromotionalMessage({
  assetsUrl,
  countryCode,
  dateFrom,
  dateUntil,
}) {
  const now = new Date().getTime();
  const bannerCountry = ["fr", "de", "ie", "us", "gb"].find(
    (country) => country === countryCode.toLowerCase()
  );
  const shouldDisplayBanner =
    bannerCountry && dateFrom < now && dateUntil > now;
  return (
    <>
      {shouldDisplayBanner && (
        <picture>
          <source
            media="(min-width: 528px)"
            srcSet={`${assetsUrl}/premier-landing-page/img/svg/${bannerCountry}-spotify-desktop.svg`}
          />
          <img
            src={`${assetsUrl}/premier-landing-page/img/svg/${bannerCountry}-spotify-mobile.svg`}
            className={styles.PremierPromotionalMessage}
            alt="ASOS Premier Spotify Premium banner"
          />
        </picture>
      )}
    </>
  );
}

PremierPromotionalMessage.propTypes = {
  assetsUrl: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  dateFrom: PropTypes.string.isRequired,
  dateUntil: PropTypes.string.isRequired,
};
